export default __webpack_public_path__ + "static/media/collapsed.6e5070b4.svg";